"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _ = require("lodash");
var event = require("../event");
var LegacyController = /** @class */ (function () {
    function LegacyController(opt) {
        var _this = this;
        this.shouldRunVisualizer = true;
        this.enableEditor = true;
        this.editorDef = [];
        this.autoId = 0;
        opt = opt || {};
        this.canvasHeight = opt.initCanvasH || 500;
        this.minCanvasHeight = opt.minCanvasH || 450;
        this.maxCanvasHeight = opt.maxCanvasH || 700;
        LegacyController.current = this;
        event.on(event.CANVAS_MOUNTED, function (_, vue) {
            if (window.BVD_CURRENT_MODULE !== _this.__name__) {
                return;
            }
            _this.vue = vue;
        });
        event.on(event.CANVAS_READY, function (_, vue) {
            if (window.BVD_CURRENT_MODULE !== _this.__name__) {
                return;
            }
            _this.vue = event.rpc("getVue");
            _this.modernRun();
        });
    }
    LegacyController.prototype.run = function () { return; };
    LegacyController.prototype.modernRun = function () {
        var _this = this;
        this.editor = $(".v-editor");
        this.canvas = $("#canvas");
        this.canvasWidth = this.canvas.innerWidth();
        this.init();
        this.initBasics();
        event.emit(event.DATA_LOADING_STARTED);
        $.get(window.gon.urls.chosen_file_paths).then(function (data) {
            _this.selectedFiles = _.mapValues(data, function (x) { return x.url; });
            if (_this.shouldRunVisualizer) {
                _this.visualizer.run();
            }
        });
    };
    LegacyController.prototype.initBasics = function () {
        var _this = this;
        this.svgSize = this.canvas.find(".svg-size");
        this.svg = this.canvas.find("svg");
        this.visualizer.legacyInit();
        event.on("bvd3.drawFinished", function () {
            _this.canvasWidth = _this.svg.width();
            _this.canvasHeight = _this.svg.height();
            _this.updateSvgSizeText();
            event.emit(event.DATA_LOADING_FINISHED);
        });
        this.updateSvgSizeText();
        // this.canvasToolbar.find(".redraw-btn").on("click", () => {
        //     this.reRunVisualizer();
        // });
        // on resize
        $(window).on("resize bvd3.canvasResize", function () {
            _this.canvasWidth = _this.canvas.innerWidth();
            _this.updateSvgSizeText();
            _this.setSvgSizeAndRedraw();
        });
        // drag resize
        this.isResizingH = false;
        this.canvas.find(".svg-resize-h").on("mousedown", function (e) {
            _this.isResizingH = true;
            _this.lastY = e.pageY;
        });
        $(document).on("mousemove", function (e) {
            if (!_this.isResizingH) {
                return;
            }
            _this.canvasHeight = _this.canvasHeight + (e.pageY - _this.lastY);
            if (_this.canvasHeight > _this.maxCanvasHeight) {
                _this.canvasHeight = _this.maxCanvasHeight;
            }
            if (_this.canvasHeight < _this.minCanvasHeight) {
                _this.canvasHeight = _this.minCanvasHeight;
            }
            _this.lastY = e.pageY;
            _this.setSvgSizeAndRedraw();
            _this.updateSvgSizeText();
        }).on("mouseup", function (e) {
            _this.isResizingH = false;
        });
    };
    LegacyController.prototype.updateSvgSizeText = function () {
        this.svgSize.html(this.canvasWidth + " &times; " + this.canvasHeight);
    };
    LegacyController.prototype.triggerCanvasResize = function () {
        // dispatch event
        var e = new $.Event("bvd3.canvasResize");
        $(window).trigger(e);
    };
    LegacyController.prototype.setSvgSizeAndRedraw = function () {
        this.visualizer.option.svgWidth = this.canvasWidth;
        this.visualizer.option.svgHeight = this.canvasHeight;
        this.visualizer.redraw("__ALL__");
    };
    LegacyController.prototype.reRunVisualizer = function () {
        this.svg.html("");
        this.visualizer.data = {};
        this.visualizer.clearAll();
        this.visualizer.run();
    };
    LegacyController.prototype.setupEditor = function (config) {
        this.editorDef = config;
        this.vue.editorConfig = this.translateEditorConfig(this.editorDef);
        this.vue.toolbarConfig = defaultToolbarDef;
    };
    LegacyController.prototype.translateEditorConfig = function (def) {
        return { sections: def.map(this.translateSectionConfig.bind(this)).filter(function (x) { return x; }) };
    };
    LegacyController.prototype.translateSectionConfig = function (section) {
        var visualizer = this.visualizer;
        function translateControlConfig(control) {
            switch (control.type) {
                case "button":
                    return control;
                case "checkbox":
                case "input":
                    var result0 = _.clone(control);
                    result0.bind = {
                        object: control.bind_to.object,
                        path: control.bind_to.path,
                        callback: function () {
                            visualizer.redraw(control.bind_to.redraw_layers || "__ALL__");
                        },
                    };
                    delete result0.bind_to;
                    return result0;
                case "select":
                    var result = _.clone(control);
                    result.options = control.options.map(function (p) { return ({ value: p[0], text: p[1] }); });
                    return result;
                case "custom":
                    return;
            }
        }
        if (section.id === "file") {
            return null;
        }
        switch (section.layout) {
            case "option-list":
                var result1 = {
                    title: section.title,
                    id: section.id,
                    layout: "single-page",
                    view: {
                        type: "list",
                        items: undefined,
                    },
                };
                result1.view.items = section.items.map(translateControlConfig).filter(function (x) { return x; });
                return result1;
            case "tabbed-option-list":
                var result2 = {
                    title: section.title,
                    id: section.id,
                    layout: "tabs",
                    tabs: undefined,
                };
                result2.tabs = section.tabs.map(function (tc) { return ({
                    name: tc.name,
                    id: tc.id,
                    view: {
                        type: "list",
                        items: tc.items.map(translateControlConfig).filter(function (x) { return x; }),
                    },
                }); });
                return result2;
            case "custom-view":
                return {
                    title: section.title,
                    id: section.id,
                    layout: "single-page",
                    view: {
                        type: "custom-legacy",
                        header_html: section.header_html,
                        body_html: section.view_html,
                    },
                };
            default:
                return null;
            // return {
            //     builtin: "unknown",
            // };
        }
    };
    LegacyController.prototype.getFileListForKey = function (key) {
        var files = [];
        this.fileList[key].files.forEach(function (e) {
            files.push({
                fid: e.id,
                name: e.filename,
            });
        });
        return files;
    };
    /* Tree view */
    LegacyController.prototype.createTreeView = function (ul, node, nodeNameGetter, liDidCreated) {
        var nodeName = nodeNameGetter(node) || "(node)";
        if (node.children) { // has children
            var li = $("<li><a>" + nodeName + "</a></li>");
            ul.append(li);
            liDidCreated(li, node);
            var childrenUl = $("<ul></ul>");
            li.append(childrenUl);
            for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
                var c = _a[_i];
                this.createTreeView(childrenUl, c, nodeNameGetter, liDidCreated);
            }
        }
        else { // doesn't has children
            var li = $("<li>" + nodeName + "</li>");
            ul.append(li);
            liDidCreated(li, node);
        }
    };
    /**
     * Must be called after createTreeView().
     * Since tree view may be loaded afterwards, need to add listeners later
     */
    LegacyController.prototype.activateTreeViews = function () {
        var treeViews = this.editor.find(".tree-view");
        treeViews.find("li>a").on("click", function (e) {
            $(e.target).parent().toggleClass("open");
        });
        treeViews.each(function (i, el) {
            var treeView = $(el);
            var bottomBar = treeView.closest(".table-container").siblings(".bottom-bar");
            bottomBar.find(".tree-show-all").on("click", function (e) {
                treeView.find("li:has(a)").addClass("open");
            });
            bottomBar.find(".tree-collapse-all").on("click", function (e) {
                treeView.find("li:has(a)").removeClass("open");
            });
        });
    };
    return LegacyController;
}());
exports.LegacyController = LegacyController;
var defaultToolbarDef = [{
        type: "btn-group",
        items: [{
                type: "button",
                name: "Download",
                icon: "download",
                callback: function () { return; },
            }, {
                type: "button",
                name: "Redraw",
                icon: "sync-alt",
                callback: function () { return; },
            }],
    }];
//# sourceMappingURL=app-base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/legacy/app-base.js
// module id = 1194
// module chunks = 0 1